<div class="modal-dialog-alert" role="document">
    <div class="modal-content v-card card modal-card">
        <div class="modal-header d-flex align-items-center">
            <div class="modal-title font-weight-600">{{ 'MAIN.CONTENT.DASHBOARD.SEARCH.TITLE' | translate }}</div>
            <div class="cursor-pointer" (click)="close()">
                <img src="assets/img/close_white.svg" alt="">
            </div>
        </div>
        <div class="modal-body">
            <div class="d-flex flex-column">
                <label class="fs-14 font-weight-500 mb-2 text-dark-grey">{{ 'MAIN.CONTENT.DASHBOARD.SEARCH.PLACEHOLDER' | translate }}</label>
                <div class="search-box">
                    <input 
                        type="text" 
                        class="form-control search-input-modal fs-14" 
                        [formControl]="searchQuery" 
                        [placeholder]="'MAIN.CONTENT.DASHBOARD.SEARCH.PLACEHOLDER' | translate"
                        (keyup.enter)="performSearch()">
                    <div class="search-icon">
                        <img src="assets/img/search.svg" alt="">
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-end mt-4">
                <button 
                    class="v-btn btn btn-secondary fs-14 font-weight-600 me-2" 
                    (click)="close()">
                    {{ 'MAIN.CONTENT.DASHBOARD.SEARCH.CANCEL' | translate }}
                </button>
                <button 
                    class="v-btn btn btn-primary fs-14 font-weight-600 text-white" 
                    (click)="performSearch()"
                    [disabled]="!searchQuery.valid">
                    {{ 'MAIN.CONTENT.DASHBOARD.SEARCH.BUTTON' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>

